import React from "react";
import { Card, Link, Pane } from "evergreen-ui";

const FilePreview = ({ data, mime }) => {
  const href = `data:${mime};base64,${data}`;

  if (!data && !mime) {
    return null;
  }

  return (
    <Pane display="flex" flexDirection="column">
      <Card border paddingTop="150%" position="relative">
        <object
          aria-label="File Preview"
          data={href}
          type={mime}
          style={{
            objectFit: "scale-down",
            position: "absolute",
            top: "0",
            left: "0",
            height: "100%",
            width: "100%",
          }}
        />
      </Card>
      <Link download href={href}>
        Download
      </Link>
    </Pane>
  );
};

export default FilePreview;
